export default {
  methods: {
    inlineBgImage(src) {
      let bgImage = new URL(`../assets/img/${src}`, import.meta.url).href;
      return {
        backgroundImage: `url("${bgImage}")`
      };
    }
  }
}
